import { validaEmails, validaNames } from "../../helpers/forms/Validation";
import { UPDATE_PRODUCT, RESET_PRODUCT, SET_PRODUCTS } from "./actionTypes";
import * as Yup from "yup";

const productBase = {
    id: null,
    name: '',
    code: '',
}

const productsBase = {
    departaments: [],
    meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 20,
        to: 1,
        total: 0
    },
}
const initialState = {
    product: { ...productBase },
    products: { ...productsBase },
    validations: {
        name: validaNames(),
        code: Yup.string().required('El identificador es obligatorio'),
    }
};

const product = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PRODUCT:
            // Actualizar el estado
            return {
                ...state,
                product: action.payload
            };
        case RESET_PRODUCT:
            return {
                ...state,
                product: { ...productBase }
            };
        case SET_PRODUCTS:
            return {
                ...state,
                products: action.payload
            };
        default:
            return state;
    }
};

export default product;
